import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import Api from "../../../../../Services/Api";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import {mapToObjectDDL} from "../../../../common/mapper";
import SimpleDateRange from "../../../../../modules/SimpleDateRange";
import M from "moment/moment";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import {fetchDataAsync} from "../../../../../Services/Utils";
import ErrorAction from "../../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {HttpStatus, Status} from "../../../../common/Constants";
import {config} from "./config";

class FakturJualNOSFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            varianOptions: [],
            warnaOptions: [],
            salesTypeOptions: [],
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        const res = await Promise.all([
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllVariant,
                setError: this.props.setError,
                menuName: "Sales Order - Faktur Jual",
                args: "",
            }),
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizpar,
                setError: this.props.setError,
                menuName: "Sales Order - Faktur Jual",
                args: {
                    paramFilters: {
                        bizparCategory: "SALES_TYPE_SALES_ORDER",
                        status: Status.ACTIVE,
                    },
                },
            }),
        ]);

        const error = [res[0], res[1]].some(r => r.ok && r.data.status === HttpStatus.FAILED);
        if (error) {
            this.props.onClickClose();
        }

        if (res[0].ok && res[0].data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                varianOptions: res[0].data.data.map(
                    (item) => mapToObjectDDL(item.namaVariant, item.kodeVariant)
                ),
            }))
        }
        if (res[1].ok && res[1].data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                salesTypeOptions: res[1].data.data.map(
                    (item) => mapToObjectDDL(item.value, item.id)
                ),
            }))
        }

        this.handleTriggerLoading();
    }

    handleValueChange = (name, value) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
            },
        }));
    };

    handleDateChange = (name, value) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
            },
        }));
    };

    handleVarianChange = async (name, value) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
                kodeWarna: null,
                warnaOptions: [],
            },
        }));

        if (!R.isNil(value)) {
            const res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllWarnaByParam,
                setError: this.props.setError,
                menuName: "Sales Order - Faktur Jual",
                args: {paramFilters: {kodeVariant: value?.value}},
            });

            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.setState((prevState) => ({
                    ...prevState,
                    warnaOptions: res.data.data.map(
                        (item) => mapToObjectDDL(item.namaWarnaKomersil, item.id)
                    ),
                }))
            }
        }
    }

    handleClearFilter = () => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            filterData: {},
        }));
    };

    getDataValue(fieldName, fallbackValue = "") {
        return !R.isNil(this.props.state.filterData) && this.props.state.filterData[fieldName]
            ? this.props.state.filterData[fieldName]
            : fallbackValue;
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    render() {
        return (
            <>
                <SimpleModal
                    title="Filter Search"
                    visible={this.props.state.filterVisible}
                    onClickClose={this.props.onClickClose}
                    content={
                        <ModalContainer>
                            <FlexView column>
                                <SimpleInput
                                    id="input_text_nomor_fj"
                                    name="nomorFJ"
                                    label="Nomor FJ"
                                    value={this.getDataValue("nomorFJ")}
                                    onChange={({target}) => this.handleValueChange(target.name, target.value)}
                                />
                                <SimpleDateRange
                                    label="Tanggal FJ"
                                    startDateName="startFJDate"
                                    endDateName="endFJDate"
                                    data={this.props.state.filterData}
                                    onStartDateChange={(_, value) =>
                                        this.handleDateChange("startFJDate", M(value).format("DD-MM-YYYY"))
                                    }
                                    onEndDateChange={(_, value) =>
                                        this.handleDateChange("endFJDate", M(value).format("DD-MM-YYYY"))
                                    }
                                />
                                <SimpleInput
                                    id="input_text_kode_cabang"
                                    name="kodeCabang"
                                    label="Kode Cabang"
                                    value={this.getDataValue("kodeCabang")}
                                    onChange={({target}) => this.handleValueChange(target.name, target.value)}
                                />
                                <SimpleInput
                                    id="input_text_nomor_pembeli"
                                    name="orderName"
                                    label="Nama Pembeli"
                                    value={this.getDataValue("orderName")}
                                    onChange={({target}) => this.handleValueChange(target.name, target.value)}
                                />
                                <SimpleInput
                                    id="input_text_nama_stnk"
                                    name="ownerName"
                                    label="Nama STNK"
                                    value={this.getDataValue("ownerName")}
                                    onChange={({target}) => this.handleValueChange(target.name, target.value)}
                                />
                                <SimpleDDL
                                    id="select_options_varian"
                                    name="kodeVariant"
                                    label="Nama Varian"
                                    box="search"
                                    isClearable
                                    options={this.state.varianOptions}
                                    value={this.getDataValue("kodeVariant")}
                                    onChange={(value, {name}) => this.handleVarianChange(name, value)}
                                />
                                <SimpleDDL
                                    id="select_options_kecamatan"
                                    name="idWarna"
                                    label="Nama Warna"
                                    box="search"
                                    isClearable
                                    options={this.state.warnaOptions}
                                    value={this.getDataValue("idWarna")}
                                    onChange={(value, {name}) => this.handleValueChange(name, value)}
                                />
                                <SimpleInput
                                    id="input_sales_name"
                                    name="salesPerson"
                                    label="Penjual"
                                    value={this.getDataValue("salesPerson")}
                                    onChange={({target}) => this.handleValueChange(target.name, target.value)}
                                />
                                <SimpleDDL
                                    id="select_options_status_fj"
                                    name="orderState"
                                    label="Status FJ"
                                    box="search"
                                    isClearable
                                    options={config.statusOptions}
                                    value={this.getDataValue("orderState")}
                                    onChange={(value, {name}) => this.handleValueChange(name, value)}
                                />
                            </FlexView>
                            <FlexView hAlignContent="right" style={{gap: "10px"}}>
                                <SimpleButton text="Clear" onClick={this.handleClearFilter}/>
                                <SimpleButton text="Terapkan" onClick={this.props.onSubmit}/>
                            </FlexView>
                        </ModalContainer>
                    }
                />
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(FakturJualNOSFilter);
